export const INTERCEPTOR_IGNORED_METHODS = ['GET', 'HEAD', 'OPTIONS'];
